export default class Part {
    static render(width, mods) {
        const WIDTH = width * SIZE.pxInMm;
        const HEIGHT = SIZE.baseHeight // TODO  
        const x = (WIDTH - 60 - (70 * (mods - 2)))
        const y = (HEIGHT - 74.6) / 2;
        const switchCount = (parseInt(mods) - 1) > 4 ? 4 : (parseInt(mods) - 1)
        return `<image href="${PARTS['switch_' + switchCount]}" x="${x}" y="${y}" />`
    }
}
